module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "load-mask-parent"
  }, [_c('div', {
    class: _vm.loadMask
  }), _vm._v(" "), (_vm.moduleConfig) ? _c('div', {
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "title-box-wrapper"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.moduleConfig.title))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moduleConfig && _vm.moduleConfig.description),
      expression: "moduleConfig && moduleConfig.description"
    }],
    staticClass: "icon icon-help",
    on: {
      "mouseover": function($event) {
        _vm.moduleDescriptionShow = true
      },
      "mouseleave": function($event) {
        _vm.moduleDescriptionShow = false
      }
    }
  }), _vm._v(" "), (_vm.getFilters.length) ? _c('toggle-button', {
    staticClass: "pull-right",
    attrs: {
      "sync": true,
      "value": !_vm.moduleConfig.filterShow,
      "height": 25,
      "width": 90,
      "labels": {
        checked: _vm.t('Show filters'),
        unchecked: _vm.t('Hide filters')
      }
    },
    on: {
      "change": function($event) {
        _vm.moduleConfig.filterShow = !_vm.moduleConfig.filterShow
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getFilters.length) ? _c('filter-value', {
    staticClass: "pull-right",
    attrs: {
      "event-bus": _vm.$root,
      "routeName": _vm.$route.name,
      "component-filter-index": 'ToggleFilterPanel'
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moduleDescriptionShow),
      expression: "moduleDescriptionShow"
    }],
    staticClass: "title-box"
  }, [_c('div', {
    staticClass: "description-box-wrapper"
  }, [_c('span', {
    staticClass: "title",
    domProps: {
      "innerHTML": _vm._s(_vm.moduleConfig.description)
    }
  }, [_vm._v(_vm._s(_vm.moduleConfig && _vm.moduleConfig.description))])])]), _vm._v(" "), _c('toggle-filter-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.moduleConfig.filterShow),
      expression: "moduleConfig.filterShow"
    }],
    attrs: {
      "filters": _vm.getFilters,
      "component-index": _vm.getComponentIndex,
      "routeName": _vm.$route.name,
      "module-config": _vm.moduleConfig
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _vm._l((_vm.moduleConfig.components || []), function(component, index) {
    return [_c('div', {
      staticClass: "bg"
    }, [_c('div', {
      staticClass: "inner clearfix"
    }, [_c(component.type, {
      tag: "component",
      attrs: {
        "config": component,
        "index": index,
        "moduleConfig": _vm.moduleConfig,
        "routeName": _vm.$route.name,
        "row-index": _vm.rowIndex,
        "eventBus": _vm.$root
      }
    })], 1)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
      staticClass: "clearfix"
    })]
  }), _vm._v(" "), _c('Modal', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isModalVisible),
      expression: "isModalVisible"
    }],
    attrs: {
      "eventBus": _vm.$root
    },
    on: {
      "close": _vm.closeModal
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-36a89b5c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/CustomModule/index.vue
// module id = 1266
// module chunks = 2